{
  "title": "Invite Volunteer to {{team}} Team",
  "titleUnnamed": "Invite Volunteer",
  "rolesTitle": "Select Roles",
  "continue": "Continue",
  "invite": "Send invite",
  "inviting": "Inviting",
  "roles": "Roles",
  "rolesHint": "Optional. Roles can be changed later from the volunteer's menu.",
  "searchPlaceholder": "Search by first name or email",
  "searchLabel": "Search people",
  "noMatches": "No one matched that search.",
  "createInstead": "Can't find who you're looking for? Create New Person",
  "searchInstead": "Search for Existing Person Instead",
  "nameLabel": "Name",
  "namePlaceholder": "Full name",
  "emailLabel": "Email",
  "emailPlaceholder": "name@example.com"
}
